import type * as React from "react";

import { cn } from "~/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // Base: layout, sizing, shape, typography, transition
        "h-8 w-full min-w-0 rounded-lg border px-2.5 py-1 text-base transition-colors outline-none",
        // Default colors
        "bg-input/70 border-border",
        // Dark
        "dark:bg-input/30",
        // Placeholder
        "placeholder:text-muted-foreground",
        // Focus-visible
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-3",
        // Disabled
        "disabled:bg-input/50 disabled:cursor-not-allowed disabled:opacity-50",
        // Dark + disabled
        "dark:disabled:bg-input/80",
        // Aria-invalid
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20 aria-invalid:ring-3",
        // Dark + aria-invalid
        "dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
        // File input
        "file:text-foreground file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium",
        // Responsive
        "md:text-sm",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
